import './style.scss';

import React from 'react';

type IconContainerProps = {
  icon?: any;
  bgColor?: string | undefined | null;
  style?: any;
  className?: string;
};

export default function IconContainer({ icon, bgColor, style, className }: IconContainerProps) {
  return (
    <div
      className={`icon-container ${className}`}
      style={{ backgroundColor: bgColor ? bgColor : 'var(--light-blue)', ...style }}>
      <span>{icon}</span>
    </div>
  );
}
